export default __webpack_public_path__ + "static/media/akar-icons_location-big.32e561bf.svg";